import React, { Component } from "react"
import PropTypes from "prop-types"
import { ColorPicker } from "./color-picker"

export class ColorInput extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    swatches: PropTypes.arrayOf(PropTypes.string),
    placement: PropTypes.oneOf(["top", "bottom"]),
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ])
  }

  state = {
    active: false
  }

  handleClick = () => {
    this.setState({ active: true })
  }

  handleChange = color => {
    this.props.onChange &&
      this.props.onChange({
        target: {
          name: this.props.name,
          value: color.hex
        }
      })
  }

  handleClose = () => {
    this.setState({ active: false })
  }

  getFriendlyColor = colorString => {
    if (colorString === "transparent") return "transparent"
    if (!colorString) return "unset"

    const canvas = document.createElement("canvas")
    const context = canvas.getContext("2d")
    context.fillStyle = colorString
    return context.fillStyle.toUpperCase()
  }

  render() {
    const { swatches, value, placement } = this.props

    return (
      <div className="relative">
        <button
          type="button"
          className="flex items-center w-full bg-gray-100 border border-gray-200 rounded-sm text-gray-800 focus:outline-none"
          style={{ padding: 6 }}
          onClick={this.handleClick}
        >
          <div
            className="w-6 h-6 rounded-sm mr-2 border border-gray-300"
            style={{ backgroundColor: value }}
          />
          {this.getFriendlyColor(value)}
        </button>
        <ColorPicker
          onChange={this.handleChange}
          onClose={this.handleClose}
          active={this.state.active}
          color={this.getFriendlyColor(value)}
          swatches={swatches}
          placement={placement}
        >
          {this.props.children}
        </ColorPicker>
      </div>
    )
  }
}
